/**
 * Normalizes inconsistent API response shapes from library endpoints.
 *
 * Observed shapes:
 *   { success: true, data: [...] }           — standard wrapper
 *   { success: true, data: { data: [...] }}  — departments, positions, industries, sub-industries
 *   [...]                                     — raw array
 *   { data: [...] }                           — axios response without success wrapper
 *
 * @param {*} response
 * @returns {Array}
 */
export function normalizeResponse(response) {
  if (!response) return [];
  if (response.success && response.data && Array.isArray(response.data.data)) return response.data.data;
  if (response.success && Array.isArray(response.data)) return response.data;
  if (Array.isArray(response)) return response;
  if (response.data && Array.isArray(response.data.data)) return response.data.data;
  if (response.data && Array.isArray(response.data)) return response.data;
  return [];
}
